export default "__VITE_ASSET__DuluyyUf__"